import api from './api';

export const getTemplates = async (programType, kind) => {
    const response = await api.get(
        `/program/${programType}/email-templates/${kind}`
    );
    return response.data;
};

export const saveTemplate = async (programType, kind, key, body) => {
    const response = await api.put(
        `/program/${programType}/email-templates/${kind}/${key}`,
        { body }
    );
    return response.data;
};

export const resetTemplate = async (programType, kind, key) => {
    const response = await api.delete(
        `/program/${programType}/email-templates/${kind}/${key}`
    );
    return response.data;
};

// The text, saved or not, as the email it would send with sample values.
// Saves and sends nothing.
export const previewTemplate = async (programType, kind, key, body) => {
    const response = await api.post(
        `/program/${programType}/email-templates/${kind}/${key}/preview`,
        { body }
    );
    return response.data;
};

const emailTemplateService = {
    getTemplates,
    saveTemplate,
    resetTemplate,
    previewTemplate,
};

export default emailTemplateService;
